module.exports = __webpack_public_path__ + "static/media/blog-02.31401dd3.jpg";